import { defaultResolutionFilterValue, ResolutionFilterValue } from '@/lib/filters/filters'
import React, { useEffect } from 'react'
import styles from './resolution-filter.module.scss'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Label } from '@/components/ui/label'

const options: Array<{ label: string; value: ResolutionFilterValue }> = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: '↑4K',
    value: '4k',
  },
  {
    label: '↓4K',
    value: '-4k',
  },
]

export type ResolutionFilterProps = {
  value?: ResolutionFilterValue
  onChange?: (value?: ResolutionFilterValue) => void
}

export default function ResolutionFilter({ value: initialValue, onChange = () => {} }: ResolutionFilterProps) {
  const [value, setValue] = React.useState<ResolutionFilterValue | undefined>(
    initialValue ?? defaultResolutionFilterValue
  )

  useEffect(() => {
    setValue(initialValue ?? defaultResolutionFilterValue)
  }, [initialValue])

  return (
    <div className={styles.main}>
      <RadioGroup
        className="tw-grid-flow-col"
        value={value}
        onValueChange={(value: ResolutionFilterValue) => {
          // For default value, we want to return undefined
          onChange(value === defaultResolutionFilterValue ? undefined : value)
        }}
      >
        {React.Children.toArray(
          options.map((o) => {
            return (
              <div className="tw-flex tw-items-center tw-space-x-2">
                <RadioGroupItem value={o.value} id={`r-${o.value}`} />
                <Label htmlFor={`r-${o.value}`}>{o.label}</Label>
              </div>
            )
          })
        )}
      </RadioGroup>
    </div>
  )
}
